import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"store"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3.5 6.5H20.5L21.5 11.5V12.5H2.5V11.5L3.5 6.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 20.5V12.5H4V20.5H13Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.5 3.5H19.5M20 12.5V20.5M3.5 6.5H20.5L21.5 11.5V12.5H2.5V11.5L3.5 6.5ZM13 12.5V20.5H4V12.5H13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Store = Vue.extend<IconProps>({
  name: 'StoreIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'store',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Store;
